























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateMemberConfig,UpdateMemberConfig,QueryMemberAllList} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class EditMemberConfigDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {
 
    }
    this.show = false
  }
  private data: any = {
 
  }
  private show = false
  private isEdit = false
  private memberList: Array<any> = []



  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.data = {...this.data,...data}
    this.isEdit = isEdit
    // 加载绑定商品
    QueryMemberAllList().then(res=>{
      this.memberList = res
    })

    if (this.data.icon) {
      this.data.iconList = this.data.icon.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.iconList = []
    }
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    memberId: [this.requiredRule],
    level: [this.requiredRule],
    commissionRate: [this.requiredRule],
  }

  public async save() {

    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        console.log(this.data)
        let result = {}
        if(this.isEdit){
          result = await UpdateMemberConfig(this.data)
        } else {
          result = await CreateMemberConfig(this.data)
        }
        if(result){
          this.close()
        }

      } else {
        this.$message.error("表单存在错误，不能保存")
        return false
      }
    })
  }
}
